import React from 'react';

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.overlayContent}>
        <div style={styles.spinner}></div>
        <span style={styles.loadingText}>Loading...</span>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  },
  overlayContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    animation: 'fadeIn 0.3s ease-out',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid white',
    borderTopColor: 'transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    color: 'white',
    fontSize: '1.125rem',
  },
};

const styleSheet = document.styleSheets[0];
styleSheet.insertRule('@keyframes spin { to { transform: rotate(360deg); } }', styleSheet.cssRules.length);
styleSheet.insertRule('@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }', styleSheet.cssRules.length);

export default LoadingOverlay;
